import { memo, type FC } from "react";
import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import { WHATSAPP_EDITOR_KEY } from "../WhatsAppCampaignConstants";

const AiFilledBadge: FC = () => {
  const { t } = useTranslation();

  return (
    <span className="wa-ai-badge">
      <Sparkles size={10} aria-hidden />
      {t(`${WHATSAPP_EDITOR_KEY}.form.ai.filled`)}
    </span>
  );
};

export default memo(AiFilledBadge);
